// extracted by mini-css-extract-plugin
export default {"editorXToolBar":"w6JFi","logo":"y5WJk","logoImage":"SFEZv","switcher":"SKth3","button":"_1x9kv"};